import React, { forwardRef } from 'react';
import classnames from 'classnames';

import InputWrapper, { getWrapperProps } from 'components/layout/InputWrapper';

import style from './Textarea.module.scss';

const Textarea = forwardRef((props, ref) => {
  const {
    disabled,
    placeholder,
    isSaved,
    value,
    setValue,
    resizeDisabled = true,
    singleLine,
    onInput,
    hideBorder,
    ...rest
  } = props;

  const wrapperProps = getWrapperProps(props);

  const textareaClassNames = classnames(style.textArea, {
    [style.hideBorder]: hideBorder,
    [style.singleLine]: singleLine,
    [style.disabled]: disabled,
    [style.saved]: isSaved,
    [style.resizeDisabled]: resizeDisabled
  });

  return (
    <InputWrapper {...wrapperProps}>
      <textarea
        onInput={onInput}
        ref={ref}
        disabled={disabled}
        className={textareaClassNames}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        {...rest}
      />
    </InputWrapper>
  );
});

export default Textarea;
